/* ============================================================
   BLACKLIST WISHLIST - portable, localStorage, no app/backend.
   - CRUD under key blacklist_wishlist_v1
   - event-delegated [data-wishlist-toggle]
   - syncs all [data-wishlist-count] badges
   - renders [data-wishlist-grid] on the wishlist page
   - exposes window.BlacklistWishlist
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'blacklist_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(id) {
    id = String(id);
    return read().some(function (i) { return String(i.id) === id; });
  }
  function itemFromEl(el) {
    return {
      id: el.getAttribute('data-product-id'),
      handle: el.getAttribute('data-product-handle') || '',
      title: el.getAttribute('data-product-title') || '',
      url: el.getAttribute('data-product-url') || '',
      price: el.getAttribute('data-product-price') || '',
      image: el.getAttribute('data-product-image') || ''
    };
  }
  function toggle(el) {
    var item = itemFromEl(el);
    if (!item.id) return false;
    var list = read();
    var idx = list.findIndex(function (i) { return String(i.id) === String(item.id); });
    var active;
    if (idx === -1) { list.push(item); active = true; }
    else { list.splice(idx, 1); active = false; }
    write(list);
    syncAll();
    return active;
  }
  function count() { return read().length; }

  function syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      var on = id && has(id);
      btn.classList.toggle('is-active', !!on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function syncBadges() {
    var n = count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (b) {
      b.textContent = n;
      b.setAttribute('data-wishlist-count', n);
      // badges ship with [hidden]; toggle it so the count actually appears when > 0
      if (n > 0) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); }
    });
  }
  function syncAll() { syncButtons(); syncBadges(); renderGrid(); }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]); }); }
  function inr(cents) { var n = parseInt(cents, 10); if (isNaN(n)) return ''; return Math.round(n / 100).toLocaleString('en-IN'); }

  function renderGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var list = read();
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    // Same canonical card as category/search/home (.myugen-collection-card). Single image
    // (no carousel - localStorage holds one), INR superscript price, clean removable heart.
    grid.innerHTML = list.map(function (i) {
      var price = inr(i.price);
      return (
        '<div class="myugen-collection-card">' +
          '<div class="myugen-collection-card__media rv-cardcar" data-rv-cardcar data-count="1">' +
            '<a class="myugen-collection-card__imglink" href="' + esc(i.url) + '" aria-label="View ' + esc(i.title) + '">' +
              '<div class="rv-cardcar__track" data-rv-track><div class="rv-cardcar__slide">' +
                (i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '" loading="lazy">' : '') +
              '</div></div>' +
            '</a>' +
            '<button type="button" class="bl-wishlist is-active" data-wishlist-toggle aria-pressed="true" aria-label="Remove from wishlist"' +
              ' data-product-id="' + esc(i.id) + '" data-product-handle="' + esc(i.handle) + '" data-product-title="' + esc(i.title) + '"' +
              ' data-product-url="' + esc(i.url) + '" data-product-price="' + esc(i.price) + '" data-product-image="' + esc(i.image) + '">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.6-10-9.3C.5 8.5 2 5 5.2 5 7 5 8.4 6 12 9c3.6-3 5-4 6.8-4C22 5 23.5 8.5 22 11.7 19.5 16.4 12 21 12 21z"/></svg>' +
            '</button>' +
          '</div>' +
          '<a class="myugen-collection-card__info" href="' + esc(i.url) + '">' +
            '<div><span class="myugen-collection-card__type"></span><h2 class="myugen-collection-card__title">' + esc(i.title) + '</h2></div>' +
            (price ? '<span class="myugen-collection-card__price"><sup class="rv-cur">INR</sup>' + price + '</span>' : '') +
          '</a>' +
        '</div>'
      );
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  });

  document.addEventListener('DOMContentLoaded', syncAll);
  if (document.readyState !== 'loading') syncAll();

  window.BlacklistWishlist = {
    read: read, has: has, toggle: toggle, count: count, sync: syncAll
  };
})();
